// extracted by mini-css-extract-plugin
module.exports = {"WizardPanel":"WizardPanel_WizardPanel__3DLV8","content":"WizardPanel_content__1Xs4h","buttons":"WizardPanel_buttons__ILqhm","backButton":"WizardPanel_backButton__27GJI"};